import type { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react'
import { cx } from './cx.js'

// ── actions ───────────────────────────────────────────────────────────────
/** `danger`: reporting, flagging, blocking, refusing, taking back: red-hinted so it reads as weighty. */
type Variant = 'primary' | 'secondary' | 'ghost' | 'accent' | 'live' | 'danger'
export function Button({
  variant = 'secondary',
  sm,
  className,
  type = 'button',
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; sm?: boolean }) {
  return (
    <button
      type={type}
      className={cx('fm-btn', `fm-btn--${variant}`, sm && 'fm-btn--sm', className)}
      {...rest}
    />
  )
}
export function LinkButton({
  variant = 'secondary',
  sm,
  className,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & { variant?: Variant; sm?: boolean }) {
  return <a className={cx('fm-btn', `fm-btn--${variant}`, sm && 'fm-btn--sm', className)} {...rest} />
}
export function IconButton({
  bare,
  className,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { bare?: boolean }) {
  return (
    <button type="button" className={cx('fm-iconbtn', bare && 'fm-iconbtn--bare', className)} {...rest} />
  )
}
